import { createReducer } from '@reduxjs/toolkit';
import { getComprehensivePage } from '../actions/comprehensivePage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getComprehensivePage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
